/** 用户树 */

import UserTree from './UserTree.vue';

export default UserTree;